<template>
  <div class="xcard"></div>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    data() {
      return {};
    },
    components: {},
    watch: {},
    methods: {
      parseLabel(option) {
        if (option == null) return '';
        var seg = option.seg_apellido;
        if (seg == null) seg = '';
        // return option.nombres + ' ' + option.pri_apellido + ' ' + seg;
        return `${option.nombres} ${option.pri_apellido} ${seg} [${option.num_doc}]`;
      },
      getmesstr(mes) {
        if (mes == 0) return 'enero';
        else if (mes == 1) return 'febrero';
        else if (mes == 2) return 'marzo';
        else if (mes == 3) return 'abril';
        else if (mes == 4) return 'mayo';
        else if (mes == 5) return 'junio';
        else if (mes == 6) return 'julio';
        else if (mes == 7) return 'agosto';
        else if (mes == 8) return 'septiembre';
        else if (mes == 9) return 'octubre';
        else if (mes == 10) return 'noviembre';
        else if (mes == 11) return 'diciembre';
      },
      getfechastr(date = Date) {
        let dia = date.getDate();
        let mes = this.getmesstr(date.getMonth());
        let anio = date.getFullYear();
        return `${dia} de ${mes} del año ${anio}`;
      },
      async asyncfindestudiante(withCursor, filtro, vue) {
        //window.console.log('asyncccc');
        let cursor = 1000000;
        const thiz = this;
        var query = filtro;
        if (query && query.length > 3) {
          vue.isloadingestudent = true;
          /* let isdocumento = /^\d+$/.test(+query);
          let sql = gql`query{ getPersonasByName(nombres:"${query}",cursor:${cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,fecha_nac, profesiones{id}, ciudad{id}, pais{id}, departamento{extension} } }`;
          if (isdocumento) {
            sql = gql`query{ getPersonasByDoc(num_doc:"${query}",cursor:${cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,fecha_nac, profesiones{id}, ciudad{id}, pais{id}, departamento{extension} } }`;
          } */
          let sql = gql`query{ getPersonasByDoc(num_doc:"${query}",cursor:${cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,fecha_nac, profesiones{id}, ciudad{id}, pais{id}, departamento{extension} } }`;
          if (/[a-zA-ZáéíóúÁÉÍÓÚñÑ]{4,}/.test(query)) {
            // mas de 3 letras seguidas es nombre
            sql = gql`query{ getPersonasByName(nombres:"${query}",cursor:${cursor}){id,num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,usuario_moodle,clave_moodle,fecha_reg,fecha_nac, profesiones{id}, ciudad{id}, pais{id}, departamento{extension} } }`;
          }
          //window.console.log(sql);
          await this.$apollo
            .query({ query: sql })
            .then((data) => {
              if (!withCursor) vue.estudiantes = [];
              var datas = [];
              vue.isloadingestudent = false;
              if (data.data == null) data.data = [];

              for (var propName in data.data) {
                if (propName == 'getPersonasByName' || propName == 'getPersonasByDoc') {
                  if (!data.data[propName]) data.data[propName] = [];
                  data.data[propName].forEach(function (e) {
                    e.text = thiz.parseLabel(e);
                    datas.push(e);
                    vue.cursor = e.id;
                  });
                }
              }

              if (withCursor) vue.estudiantes = datas.concat(vue.estudiantes);
              else vue.estudiantes = datas;
              vue.msg = '';
              thiz.$emit('resultadobusquedaest');
            })
            .catch((error) => {
              window.console.error(error);
              vue.isloadingestudent = false;
            });
        }
      },
      async asyncfindpersona(filtro) {
        var query = filtro;
        if (query && query.length > 3) { 
          let sql = gql`query{ getPersonaByNumDoc(num_doc:"${query}"){id,num_doc,nombres,pri_apellido,seg_apellido,telefono1,telefono2,email,fecha_nac,sexo,tipo,est_civil,domicilio,is_verificado, profesiones{id}, grados{id nombre abreviatura titulo}, ciudad{id}, pais{id}, departamento{id extension}, idinstitucion } }`;

          const r = await this.$apollo
            .query({ query: sql })
            .then(({ data }) => data)
            .catch((error) => {
              window.console.error(error);
            });
          if(r.getPersonaByNumDoc){
            return [r.getPersonaByNumDoc]
          }

          return []
        }
      },
    },
    mounted() {},
  };
</script>
